(function () {
  if (customElements.get('complete-the-set-monogram')) return;

  function n(v) {
    var x = parseFloat((v || '0').toString().replace(/,/g, ''));
    return isNaN(x) ? 0 : x;
  }

  function normalizeVariantTitle(title) {
    return (title || '')
      .split('/')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(function (s) {
        return s !== '';
      })
      .sort()
      .join('|');
  }

  function closeEveryOpenPopup() {
    document.querySelectorAll('.monogramming_popup_main.open').forEach(function (el) {
      el.classList.remove('open');
    });
    document.querySelectorAll('.monogramming_main.open').forEach(function (el) {
      el.classList.remove('open');
    });
    document.body.classList.remove('monogramming_open');
  }

  class CompleteTheSetMonogram extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('[data-cts-monogram-toggle]');
      this.popup = this.querySelector('.monogramming_popup_main');
      this.closeBtn = this.querySelector('[data-cts-monogram-close]');
      this.submitBtn = this.querySelector('[data-cts-monogram-submit]');
      this.item = this.closest('complete-the-set-item');
      this.currentVariant = null;

      if (this.checkbox) this.checkbox.addEventListener('change', this.onToggle.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
      if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmit.bind(this));

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('input', this.onInput.bind(this));

      // Stop these three event types from ever reaching document, where the
      // theme's global assets/monogramming.js still listens (un-scoped, for
      // the single instance on the main product page). Attached last so our
      // own handlers above run first.
      ['click', 'change', 'input'].forEach((type) => {
        this.addEventListener(type, (e) => e.stopPropagation());
      });

      this._outsideClickHandler = this.onDocumentClick.bind(this);

      if (this.item) {
        // The item (our parent custom element) upgrades before we do, so its
        // currentVariant is already set by the time our constructor runs.
        this.currentVariant = this.item.currentVariant || null;

        this.item.addEventListener('cts:variant-change', (e) => {
          this.currentVariant = e.detail.variant;
          this.applyVariantInitialsOverride();
          this.refreshTotal();
        });
      }

      this.applyVariantInitialsOverride();
    }

    onToggle() {
      if (this.checkbox.checked) {
        this.applyVariantInitialsOverride();
        this.triggerSingleMonogrammingStyle();
        setTimeout(() => this.open(), 400);
      } else {
        this.close();
      }
    }

    open() {
      closeEveryOpenPopup();
      if (this.popup) this.popup.classList.add('open');
      this.classList.add('open');
      document.body.classList.add('monogramming_open');
      document.addEventListener('click', this._outsideClickHandler);
    }

    close() {
      if (this.popup) this.popup.classList.remove('open');
      this.classList.remove('open');
      document.body.classList.remove('monogramming_open');
      document.removeEventListener('click', this._outsideClickHandler);
    }

    onDocumentClick(e) {
      if (!this.popup || !this.popup.classList.contains('open')) return;
      if (!e.target.closest('.monogramming_popup')) this.close();
    }

    triggerSingleMonogrammingStyle() {
      var options = this.querySelectorAll('.selection_box_single_main.monograming_style .select_single');
      if (options.length === 1) options[0].click();
    }

    applyVariantInitialsOverride() {
      var variantId = this.currentVariant ? String(this.currentVariant.id) : '';
      var dynamicContainer = this.querySelector('.monogramming_initials_dynamic');
      var templates = this.querySelector('.monogramming_initials_templates');
      if (!dynamicContainer || !templates) return;

      var selectedTemplate = variantId
        ? templates.querySelector('template[data-monogramming-initials-template="' + variantId + '"]')
        : null;
      if (!selectedTemplate) {
        selectedTemplate = templates.querySelector('template[data-monogramming-initials-template="default"]');
      }
      if (!selectedTemplate) return;

      var nextHtml = selectedTemplate.innerHTML.trim();
      if (nextHtml !== dynamicContainer.innerHTML.trim()) {
        dynamicContainer.innerHTML = nextHtml;
      }

      setTimeout(() => {
        var selectedStyle = this.querySelector('.monograming_style .monogramming_style_select.selected');
        if (selectedStyle && selectedStyle.getAttribute('value') === 'Initials') {
          var box = this.querySelector('.selection_box_single_main.monograming_initials');
          if (box) box.style.display = 'block';
        }
        this.triggerSingleMonogrammingStyle();
      }, 0);
    }

    onClick(e) {
      var styleSelect = e.target.closest('.monogramming_style_select');
      if (styleSelect) return this.handleStyleSelect(styleSelect);

      var initialSelect = e.target.closest('.monogramming_initial_select');
      if (initialSelect) return this.handleInitialSelect(initialSelect);

      var designSelect = e.target.closest('.monograming_design .select_single');
      if (designSelect) return this.handleDesignSelect(designSelect);

      var colorSelect = e.target.closest('.selected_monogramming .monograming_color .select_single');
      if (colorSelect) return this.handleColorSelect(colorSelect);

      var genericSelect = e.target.closest('.variant_details .selection_box_single_main .select_single');
      if (genericSelect) return this.handleGenericVariantSelect(genericSelect);

      var anySelect = e.target.closest('.selection_box_single_main .select_single');
      if (anySelect) this.handleGenericOptionSelect(anySelect);
    }

    handleStyleSelect(el) {
      var group = el.closest('.selection_box_single');
      if (group) group.querySelectorAll('.selected').forEach((s) => s.classList.remove('selected'));
      el.classList.add('selected');
      var current = el.getAttribute('value');
      var styleInput = this.querySelector('.monogram_sytle_properties');
      if (styleInput) styleInput.value = current;

      var initials = this.querySelector('.selection_box_single_main.monograming_initials');
      var nameBox = this.querySelector('.enter_your_name_box');
      var nameDateTime = this.querySelector('.monograming_name_date_time');
      var design = this.querySelector('.monograming_design');

      if (current === 'Initials') {
        if (initials) initials.style.display = 'block';
        if (nameBox) nameBox.classList.remove('selected_monogramming');
        if (nameDateTime) nameDateTime.classList.remove('selected_monogramming');
        if (design) design.classList.remove('monograming_design_hide');
      } else if (current === 'Name') {
        if (initials) initials.style.display = 'none';
        if (nameBox) nameBox.classList.add('selected_monogramming');
        if (nameDateTime) nameDateTime.classList.remove('selected_monogramming');
        if (design) design.classList.remove('monograming_design_hide');
      } else if (current === 'Name, Date & Time') {
        var center = this.querySelector('.monograming_design .selection_box_single .select_single[value="Center"]');
        if (center) center.click();
        if (initials) initials.style.display = 'none';
        if (nameBox) nameBox.classList.remove('selected_monogramming');
        if (nameDateTime) nameDateTime.classList.add('selected_monogramming');
        if (design) design.classList.add('monograming_design_hide');
      } else {
        if (initials) initials.style.display = 'none';
        if (nameBox) nameBox.classList.remove('selected_monogramming');
        if (nameDateTime) nameDateTime.classList.remove('selected_monogramming');
      }

      this.querySelectorAll('.main_property').forEach((input) => (input.value = ''));
      this.querySelectorAll('.mono_img_position .monogramming_text_img').forEach((el) => el.remove());

      this.refreshTotal();
    }

    handleInitialSelect(el) {
      var group = el.closest('.selection_box_single');
      if (group) group.querySelectorAll('.selected').forEach((s) => s.classList.remove('selected'));
      el.classList.add('selected');
      var current = el.getAttribute('value');

      var box = this.querySelector('.enter_your_initials_box');
      if (box) box.style.display = 'block';

      this.querySelectorAll('.enter_your_initial_single').forEach((single) => {
        single.classList.toggle('selected_monogramming', single.getAttribute('value') === current);
      });

      setTimeout(() => {
        var activeVariant = this.querySelector(
          '.monograming_initials .selected_monogramming .variant_details .select_single.selected'
        );
        if (activeVariant) activeVariant.click();
      }, 200);
    }

    handleDesignSelect(el) {
      var group = el.closest('.monograming_design').querySelectorAll('.select_single.selected');
      group.forEach((s) => s.classList.remove('selected'));
      el.classList.add('selected');
      var position = el.getAttribute('value');
      var positionClass = el.getAttribute('positionclass');
      var preview = this.querySelector('.mono_img_position div');
      if (preview) preview.className = positionClass || '';
      var posInput = this.querySelector('.monograming_design .monogram_postion_value');
      if (posInput) posInput.value = position;
    }

    handleColorSelect(el) {
      var group = el.closest('.variant_details .selection_box_single');
      if (group) group.querySelectorAll('.selected').forEach((s) => s.classList.remove('selected'));
      el.classList.add('selected');
      this.handleGenericOptionSelect(el);

      var colorCode = el.getAttribute('colorcode');
      this.querySelectorAll('.mono_img_position .monogramming_text_img').forEach((span) => {
        span.style.color = colorCode;
      });
      this.refreshTotal();
    }

    handleGenericVariantSelect(el) {
      var group = el.closest('.variant_details .selection_box_single');
      if (group) group.querySelectorAll('.selected').forEach((s) => s.classList.remove('selected'));
      el.classList.add('selected');
      this.handleGenericOptionSelect(el);
      this.updateFontPreview();
      this.refreshTotal();
    }

    handleGenericOptionSelect(el) {
      var value = el.getAttribute('value');
      var container = el.closest('.selection_box_single_main');
      if (!container) return;
      var display = container.querySelector('.selected_option_value');
      if (display) display.textContent = value;
      var hidden = container.querySelector('.monogram_option_vlaue');
      if (hidden) hidden.value = value;
    }

    updateFontPreview() {
      var selectedFont = this.querySelector('.selected_monogramming .monograming_font .monograming_font_select.selected');
      var preview = this.querySelector('.mono_img_position');
      if (!preview) return;
      var fontValue = selectedFont ? selectedFont.getAttribute('value') : '';
      preview.className = preview.className.replace(/(^|\s)font-\S+/g, '');
      if (fontValue) {
        preview.style.fontFamily = fontValue;
        preview.classList.add('font-' + fontValue.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
      }
    }

    onInput(e) {
      var input = e.target.closest('.main_property');
      if (!input) return;

      var next = input.nextElementSibling;
      if (next) next.style.display = input.value !== '' ? 'none' : 'block';

      if (input.classList.contains('monogram_text_box_initials') || input.classList.contains('monogram_text_box_name')) {
        input.value = input.value.toUpperCase();
      }

      this.updatePreviewText();
    }

    updatePreviewText() {
      var preview = this.querySelector('.mono_img_position');
      var inner = preview ? preview.querySelector('div') : null;
      if (!preview || !inner) return;

      var colorEl = this.querySelector('.selected_monogramming .monograming_color .select_single.selected');
      var colorCode = colorEl ? colorEl.getAttribute('colorcode') : '';
      var styleInput = this.querySelector('.monogram_sytle_properties');
      var selectedStyle = styleInput ? styleInput.value : '';

      preview.querySelectorAll('.preview-date, .preview-time').forEach((el) => el.remove());
      inner.querySelectorAll('.monogramming_text_img').forEach((el) => el.remove());

      if (selectedStyle === 'Name, Date & Time') {
        var nameVal = this.getPropertyValue('Your Name');
        var dateVal = this.getPropertyValue('Your Date');
        var timeVal = this.getPropertyValue('Your Time');
        if (nameVal)
          inner.insertAdjacentHTML(
            'beforeend',
            '<span style="color:' + colorCode + ';" class="monogramming_text_img preview-name">' + nameVal + '</span>'
          );
        if (dateVal)
          preview.insertAdjacentHTML(
            'beforeend',
            '<span style="color:' + colorCode + ';" class="monogramming_text_img preview-date">' + dateVal + '</span>'
          );
        if (timeVal)
          preview.insertAdjacentHTML(
            'beforeend',
            '<span style="color:' + colorCode + ';" class="monogramming_text_img preview-time">' + timeVal + '</span>'
          );
      } else {
        this.querySelectorAll('.selected_monogramming .main_property').forEach((input) => {
          if (input.value !== '') {
            inner.insertAdjacentHTML(
              'beforeend',
              '<span style="color:' + colorCode + ';" class="monogramming_text_img">' + input.value + '</span>'
            );
          }
        });
      }
    }

    getPropertyValue(propName) {
      var input = this.querySelector('.selected_monogramming .main_property[name="properties[' + propName + ']"]');
      return input ? input.value : '';
    }

    refreshTotal() {
      var mainPrice = 0;
      var mainCompare = 0;
      if (this.currentVariant) {
        mainPrice = n(this.currentVariant.price) / 100;
        mainCompare = n(this.currentVariant.compare_at_price || this.currentVariant.price) / 100;
      } else {
        var map = this.querySelector('.monogramming_variant_price_map span');
        if (map) {
          mainPrice = n(map.getAttribute('data-main-variant-price')) / 100;
          mainCompare = n(map.getAttribute('data-main-variant-compare')) / 100;
        }
      }

      var title = '';
      this.querySelectorAll('.selected_monogramming .variant_details .selection_box_single .selected').forEach((el) => {
        var val = el.getAttribute('value');
        if (val) title += (title === '' ? '' : ' / ') + val;
      });

      var monoPrice = 0;
      var monoCompare = 0;
      var normalized = normalizeVariantTitle(title);
      this.querySelectorAll('.selected_monogramming .variant_details_get .variant_details_single').forEach((el) => {
        if (normalized !== '' && normalizeVariantTitle(el.getAttribute('vartitle')) === normalized) {
          monoPrice = n(el.getAttribute('varprice')) / 100;
          monoCompare = n(el.getAttribute('varcompare') || el.getAttribute('varprice')) / 100;
        }
      });

      var totalPrice = mainPrice + monoPrice;
      var totalCompare = mainCompare + monoCompare;

      var totalEl = this.querySelector('.monogramming_prd_total .total');
      var compareEl = this.querySelector('.monogramming_prd_total .compare_total');
      var compareWrap = this.querySelector('.monogramming_prd_total .compare-at-total');
      if (totalEl) totalEl.textContent = totalPrice.toFixed(2);
      if (compareEl && compareWrap) {
        if (totalCompare > totalPrice) {
          compareEl.textContent = totalCompare.toFixed(2);
          compareWrap.classList.remove('hidden');
        } else {
          compareWrap.classList.add('hidden');
        }
      }
    }

    onSubmit() {
      var title = '';
      this.querySelectorAll('.selected_monogramming .variant_details .selection_box_single .selected').forEach((el) => {
        var val = el.getAttribute('value');
        if (val) title += (title === '' ? '' : ' / ') + val;
      });

      var allFilled = true;
      this.querySelectorAll('.selected_monogramming .main_property').forEach((input) => {
        var next = input.nextElementSibling;
        if (input.value !== '') {
          if (next) next.style.display = 'none';
        } else {
          allFilled = false;
          if (next) next.style.display = 'block';
        }
      });
      if (!allFilled) return;

      var normalized = normalizeVariantTitle(title);
      var addonVariantId = null;
      this.querySelectorAll('.selected_monogramming .variant_details_get .variant_details_single').forEach((el) => {
        if (normalized !== '' && normalizeVariantTitle(el.getAttribute('vartitle')) === normalized) {
          addonVariantId = el.getAttribute('varid');
        }
      });

      if (!addonVariantId) {
        this.setError('Sorry, that combination of font and colour isn’t available. Please choose a different combination.');
        return;
      }

      if (!this.currentVariant) {
        this.setError('Please choose a size before adding to basket.');
        return;
      }

      var quantity = this.item && this.item.quantityInput ? parseInt(this.item.quantityInput.value, 10) || 1 : 1;
      var uniqueCode = 'U-' + Date.now();

      // Scoped to .selected_monogramming (the one active style/initials-count branch) plus
      // the two fields that live outside it. Several inactive branches (other styles, other
      // initials counts) sit hidden in the DOM at the same time with the same properties[...]
      // names — querying the whole component would silently pick up their stale values.
      var mainProperties = { Monogramming: uniqueCode };

      var styleInput = this.querySelector('.monogram_sytle_properties');
      if (styleInput && styleInput.value !== '') mainProperties['Monogramming style'] = styleInput.value;

      this.querySelectorAll('.selected_monogramming [name^="properties["]').forEach((input) => {
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (!match) return;
        if (input.value !== '') mainProperties[match[1]] = input.value;
      });

      var positionInput = this.querySelector('.monograming_design .monogram_postion_value');
      if (positionInput && positionInput.value !== '') mainProperties['Monogramming Position'] = positionInput.value;

      var payload = {
        items: [
          { id: addonVariantId, quantity: quantity, properties: { Monogramming: uniqueCode, 'Monogramming Product': 'Yes' } },
          { id: this.currentVariant.id, quantity: quantity, properties: mainProperties },
        ],
      };

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        payload.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
      }

      this.setError('');
      if (this.submitBtn) this.submitBtn.setAttribute('aria-disabled', 'true');

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((res) =>
          res.json().then((data) => {
            if (!res.ok) throw data;
            return data;
          })
        )
        .then((data) => {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'complete-the-set-monogram', cartData: data });
          }
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
            cartDrawer.renderContents(data);
          }
          this.checkbox.checked = false;
          this.onToggle();
        })
        .catch((err) => {
          this.setError((err && (err.description || err.message)) || 'Something went wrong adding this to your basket.');
        })
        .finally(() => {
          if (this.submitBtn) this.submitBtn.removeAttribute('aria-disabled');
        });
    }

    setError(message) {
      if (this.item && typeof this.item.setError === 'function') this.item.setError(message);
    }
  }

  customElements.define('complete-the-set-monogram', CompleteTheSetMonogram);
})();
